const { ICONS_CATEGORIES, ICONS_CATEGORIES_URL } = require('constants/expensesByCategories/iconsCategories');

const getCategoryIcon = (code) => {
    return (
        ICONS_CATEGORIES[code]
    )
}

const getCategoryIconURL = (category) => {
    return (
        `${ICONS_CATEGORIES_URL}${category}.png`
    )
}

module.exports = {
    getCategoryIcon,
    getCategoryIconURL
};